import React from "react";

// Brand mark from the 2026 refresh: black rounded tile with a teal bottle glyph.
export default function WineMark({ size = 36, label }) {
  const radius = Math.round(size * 0.28);
  const glyph = Math.round(size * 0.5);
  return (
    <span className="vt-brand" style={{ display: "inline-flex", alignItems: "center", gap: 14, minWidth: 0 }}>
      <span
        className="vt-brand__mark"
        style={{
          width: size,
          height: size,
          borderRadius: radius,
          background: "#0C0E0E",
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "center",
          flexShrink: 0,
        }}
      >
        <svg width={glyph} height={glyph} viewBox="0 0 18 18" fill="none" aria-hidden="true">
          <path
            d="M6.5 2h5v4.2c0 1.2 2.6 2.6 2.6 5.1V16H3.9v-4.7C3.9 8.8 6.5 7.4 6.5 6.2V2z"
            stroke="#00E5C7"
            strokeWidth="1.5"
            strokeLinejoin="round"
          />
        </svg>
      </span>
      {label && (
        <span
          className="vt-brand__label"
          style={{
            fontFamily: '"Instrument Sans", system-ui, sans-serif',
            fontSize: 15,
            fontWeight: 600,
            letterSpacing: "-0.01em",
            color: "#0C0E0E",
          }}
        >
          {label}
        </span>
      )}
    </span>
  );
}
